module.exports = __webpack_public_path__ + "static/img/kouhao_.509341e0.png";